import { render, staticRenderFns } from "./VPlayerVideo.vue?vue&type=template&id=3bc505b4&scoped=true&"
import script from "./VPlayerVideo.vue?vue&type=script&lang=js&"
export * from "./VPlayerVideo.vue?vue&type=script&lang=js&"
import style0 from "./VPlayerVideo.vue?vue&type=style&index=0&id=3bc505b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc505b4",
  null
  
)

export default component.exports